import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { UserService } from './core/services/user/user.service';
import { clearAuthStorage, hasRequiredRole } from './core/services/common-utils/common-utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent {
  title = 'AATIdentityManagementUI';
  isAuthorized = false;
  private isLoggingOut = false;

  constructor(public readonly authService: AuthService,
    private readonly userService: UserService
  ) {
      this.handleAuth0Error();
      this.handleBFCache();
  }

  ngOnInit(): void {
    this.authService.isAuthenticated$.subscribe((isAuthenticated: boolean) => {
      if (isAuthenticated) {
        this.onAuthenticated();
      } else {
        this.onUnauthenticated();
      }
    });
    this.userService.getUser().subscribe(user => {
      this.isAuthorized = hasRequiredRole(user.roles);
    });
  }

  private onAuthenticated(): void {
    this.userService.setUser();
    this.userService.monitorTokenChanges();
  }

  private onUnauthenticated(): void {
    if (!this.isLoggingOut && navigator.onLine) {
      this.isAuthorized = false;
      this.loginWithRedirect();
    }
  }

  handleAuth0Error() {
    this.authService.error$.subscribe((error: any) => {
      console.error('Auth0 error:', error);
      // If offline, the error is a transient network failure during a refresh-token
      // grant — NOT a genuine auth error. Skip logout; Auth0 will silently refresh
      // on the next API call once connectivity is restored.
      if (!navigator.onLine) {
        return;
      }
      this.isLoggingOut = true;
      clearAuthStorage();
      this.authService.logout({
        logoutParams: {
          returnTo: window.location.origin
        }
      });
    });
  }

  handleBFCache() {
    // Listen for the pageshow event
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        window.location.reload(); // Force reload to ensure the user is logged out
      }
    });
  }

  loginWithRedirect() {
    // Mark this as an explicit login request (not a silent re-auth)
    sessionStorage.setItem('explicit_login', 'true');
    this.authService.loginWithRedirect({ appState: { target: window.location.pathname } });
  }

}
